import React, { Fragment, memo } from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { clientNumberField } from 'constants/fields';

import styles from './styles.module.scss';

const fields = [clientNumberField];

const AddAccount = () => (
  <Fragment>
    <UTLabel darkGray style={styles.codeSentLabel}>
      {message('Signup:registerAccount')}
    </UTLabel>
    <UTForm fields={fields} fieldClasses={{ container: styles.field }} />
  </Fragment>
);

export default memo(Radium(AddAccount));
